module.exports = __webpack_public_path__ + "img/book-001.a516cc87.jpg";